import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {MarkNotificationAllRead as MarkAllReadMutation} from 'nutshell-graphql-types';

import MarkNotificationAllRead from '../mutations/mark-notification-all-read.graphql';

export const useMarkAllNotificationsRead = () => {
    const [markAllRead, {loading, error}] = useMutation<MarkAllReadMutation, null>(
        MarkNotificationAllRead
    );

    return {
        markAllRead: () => {
            return markAllRead();
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
